import React from "react";
import IconButtons from "../../components/IconButtons/IconButtons";
import {
  delete_active_icon,
  delete_disabled_icon,
  edit_active_icon,
  edit_disabled_icon,
  listing_icon,
  plus_active_icon,
  plus_disabled_icon,
  dissociate_active_icon,
  dissociate_disabled_icon,
  associate_default_icon,
  dissociate_default_icon,
  associate_default_disabled_icon,
  dissociate_default_disabled_icon
} from "../../constants/icons";
import { Box, Button, Typography } from "@mui/material";
import { font_16, font_17 } from "../../utils/utils";
import BootstrapTooltip from "../../components/BootstrapTooltip/BootstrapTooltip";

const BootcampModuleViewActionItems = ({
  handleDeleteModalOpen,
  handleOpenEditModule,
  enableEdit,
  enableDelete,
  handleCreateBatchOpen,
  isModuleCompleted,
  isModuleCancelled,
  isModuleActive,
  isBootcampCompleted,
  isBootcampCancelled,
  handleListAssessments,
  canListAssessmentQuestions,
  handleBulkCreateBatchOpen,
  handleAssociateBootcampModalOpen,
  handleDissociateModalOpen,
  moduleData,
  bootcampData,
}) => {
  const isAnyCancelled = isModuleCancelled || isBootcampCancelled;
  const isCompleted = isBootcampCompleted || isModuleCompleted;

  const getDisabledTooltip = () => {
    if (isBootcampCompleted) return "Bootcamp is completed";
    if (isModuleCompleted) return "Module is completed";
    if (isModuleActive) return "Module is active";
    return null;
  };

  const renderActionButton = (label, onClick, disabled) => (
    <BootstrapTooltip title={getDisabledTooltip()}>
      <Box>
        <Button
          variant="contained"
          color="secondary"
          className="header-action-btn margin-right-2"
          onClick={onClick}
          disabled={disabled}
        >
          <Typography variant="outlineBtnLabel">{label}</Typography>
        </Button>
      </Box>
    </BootstrapTooltip>
  );

  return (
    <>
      {canListAssessmentQuestions && (
        <IconButtons
          classList="margin-right-1"
          width={font_17}
          height={font_16}
          image={listing_icon}
          handleClick={handleListAssessments}
          tooltip="List Assessments"
        />
      )}

      {enableEdit && !isAnyCancelled && (
        <>
          <IconButtons
            classList="margin-right-1"
            width={font_17}
            height={font_16}
            image={edit_active_icon}
            disabledImage={edit_disabled_icon}
            handleClick={handleOpenEditModule}
            tooltip="Edit Module"
            disabled={isModuleCompleted}
            disabledTooltip={getDisabledTooltip()}
          />
          <IconButtons
            classList="margin-right-1"
            width={font_17}
            height={font_16}
            image={associate_default_icon}
            disabledImage={associate_default_disabled_icon}
            handleClick={(e) =>
              handleAssociateBootcampModalOpen(e, bootcampData, moduleData)
            }
            tooltip="Associate Bootcamp"
            disabled={isCompleted}
            disabledTooltip={getDisabledTooltip()}
          />
          {moduleData?.bootcamps?.totalResults > 1 && (
            <IconButtons
              classList="margin-right-1"
              width={font_17}
              height={font_16}
              image={dissociate_default_icon}
              disabledImage={dissociate_default_disabled_icon}
              handleClick={(e) =>
                handleDissociateModalOpen(e, moduleData, bootcampData)
              }
              tooltip="Dissociate Module"
              disabled={isCompleted || isModuleActive}
              disabledTooltip={getDisabledTooltip()}
            />
          )}
        </>
      )}

      {enableDelete && !isAnyCancelled && (
        <IconButtons
          classList="margin-right-1"
          width={font_17}
          height={font_16}
          image={delete_active_icon}
          handleClick={() => handleDeleteModalOpen("module")}
          tooltip="Delete Module"
          disabledImage={delete_disabled_icon}
          disabled={isModuleCompleted || isModuleActive}
          disabledTooltip={getDisabledTooltip()}
        />
      )}

      {enableEdit && !isAnyCancelled && (
        <>
          {renderActionButton(
            "Create Bulk Batches",
            handleBulkCreateBatchOpen,
            isModuleCompleted
          )}
          {renderActionButton(
            "Create Batches",
            handleCreateBatchOpen,
            isModuleCompleted
          )}
        </>
      )}
    </>
  );
};

export default BootcampModuleViewActionItems;
